<template>
  <main></main>
</template>

<script>
export default {
  name: "Dashboard",
  data() {
    return {
      users: [
        {
          id: 1,
          name: "Sally Dennis",
          is_you: true,
          avatar: {
            src: require("@/assets/img/sally_temp.png"),
            short: "sd",
          },
          show_drop: false,
          sliderValue: 50,
        },

        {
          id: 2,
          name: "Michael Thornton",
          is_you: false,
          avatar: {
            src: "",
            short: "mt",
          },
          show_drop: false,
          sliderValue: 50,
        },
      ],

      record_active: false,
      room_lock: false,
      let_in_drop: true,
      not_logged_in: false,

      roomData: null,
      streamCaptionsClient: null,
    };
  },

  mounted() {
    this.chekLoginUser();
  },

  methods: {
    showSettings() {
      this.$emit("showSettings", this.modalName);
    },
  },
};
</script>

<style lang="scss">
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.preloader,
.smile {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 64px;
  display: block;
}

.preloader {
  animation: spin 2s infinite reverse;
}

.dashboard {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
  margin-top: 0;
  margin-bottom: 0;
  height: calc(100vh - 64px);

  @media all and (max-width: 1000px) {
    height: calc(100vh - 96px);
  }

  @media all and (max-width: 767px) {
    overflow: hidden;
    padding: 0;
  }
}

.call_area {
  border-radius: 16px;
  line-height: 0;
  width: -webkit-fill-available;
  height: 100%;

  .name {
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    padding: 4px 8px;
    border-radius: 8px;
    background-color: #fffeff;
    position: absolute;
    left: 16px;
    bottom: 16px;
  }

  .user_img {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 0;

    img {
      width: 100%;
      height: 100%;
      min-height: 100%;
      min-width: 100%;
      object-position: center;
      object-fit: cover;
    }
  }

  &.mobile {
    background-color: transparent;

    .user_img {
      left: 50%;
      border-radius: 16px 0 0 16px;
      overflow: hidden;
    }

    .name {
      left: calc(50% + 16px);
    }
  }

  .more_btn {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 40px;
    height: 24px;
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.16);

    @media all and (max-width: 767px) {
      right: 8px;
      top: 8px;
    }

    img {
      width: 22px;
    }
  }
}

.getting_ready {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  & + .call_area {
    border-radius: 16px;
  }

  p {
    color: #000;
    font-family: "Playfair Display", serif;
    font-size: 36px;
    font-weight: 400;
    line-height: 48px;
    text-align: center;
    margin-bottom: 64px;

    @media all and (max-width: 767px) {
      font-size: 24px;
      line-height: 32px;
      margin-bottom: 32px;
    }
  }

  .color_btn {
    width: 152px;

    @media all and (max-width: 767px) {
      width: 100%;
      margin-bottom: 32px;
    }
  }
}

.setting_bar {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  width: 100%;

  button,
  .lock {
    display: flex;
    align-items: center;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;

    img {
      margin-right: 16px;
      width: 22px;
    }
  }

  .lock_drop_call {
    flex: 1 1 40%;

    @media all and (max-width: 767px) {
      flex: 1 1 25%;
    }

    span {
      cursor: pointer;

      @media all and (max-width: 767px) {
        display: none;
      }
    }

    button p {
      @media all and (max-width: 767px) {
        display: none;
      }
    }
  }

  .lock {
    p,
    span {
      cursor: pointer;
    }

    &:hover {
      & + .lock_drop {
        opacity: 1;
        transition: opacity 180ms;
      }
    }

    &:nth-child(3) {
      justify-content: center;
    }

    span {
      color: rgba(0, 0, 0, 0.64);
      font-family: "Nunito Sans", sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      margin-right: 36px;

      &:after {
        content: "";
        position: absolute;
        right: -20px;
        top: 10px;
        display: block;
        width: 4px;
        height: 4px;
        border-radius: 2px;
        background-color: #000;
      }
    }
  }

  .settings {
    flex: 1 1 40%;
    display: flex;
    justify-content: flex-end;

    span {
      cursor: pointer;
    }

    @media all and (max-width: 767px) {
      flex: 1 1 25%;
    }

    img {
      width: 22px;
      margin-left: 16px;
      margin-right: 0;
    }

    @media all and (max-width: 767px) {
      span {
        display: none;
      }
    }
  }
}

.drop.lock_drop {
  top: 50px;
  left: 10px;
  padding-left: 32px;
  padding-right: 32px;

  @media all and (max-width: 767px) {
    padding-left: 16px;
    padding-right: 16px;
    left: 0;
    top: 30px;
    width: calc(100vw - 32px);
  }

  p {
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: left;
  }
}
</style>
